import { graphql } from '~/__gql__';

export const mutationRequestBidderIntroductionEmailUpsell = graphql(/* GraphQL */ `
  mutation RequestBidderIntroductionEmailUpsell {
    requestBidderIntroductionEmailUpsell
  }
`);
